/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import Empty from './Empty';

const steps = [
  {
    id: 1,
    key: 'personalInfo',
    defaultCompleted: false,
  },
  {
    id: 2,
    key: 'bankInfo',
    defaultCompleted: false,
  },
  {
    id: 3,
    key: 'practiceData',
    defaultCompleted: false,
  },
  {
    id: 4,
    key: 'contractAgreement',
    defaultCompleted: false,
  },
  {
    id: 5,
    key: 'form6101',
    defaultCompleted: false,
  },
  {
    id: 6,
    key: 'form101',
    defaultCompleted: false,
  },
  {
    id: 7,
    key: 'taxAdjustment',
    defaultCompleted: false,
  },
];

export function CompletedSteps({
                                 data = [],
                                 className
                               }) {
  const mapSteps = step => {
    const {
      id, key, defaultCompleted
    } = step;
    const completed = data[key] || defaultCompleted;

    return (
      <div
        key={id}
        className={`mb-2 d-flex align-items-center w-100 ${className}`}
      >
        <div className="font-size-m">
          {
            completed
              ? (
                <img
                  src={toAbsoluteUrl('/media/svg/Check.svg')}
                  alt="completed"
                />
              )
              : (
                <img
                  src={toAbsoluteUrl('/media/svg/Cross.svg')}
                  alt="not completed"
                />
              )
          }
        </div>
        <div className={`font-weight-bolder completedSteps-label ${completed && 'completedSteps-label-completed'}`}>
          <FormattedMessage
            id={`userDetails-steps-${key}-label`}
            defaultMessage={key}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={`card card-custom ${className}`}>
        <div className="card-header border-0 justify-content-start align-items-center flex-nowrap">
          <img src={toAbsoluteUrl("/media/svg/Stairs-blue.svg")} className="mr-3" alt="file icon"/>
          <h3 className="card-title font-weight-bolder text-dark">
            <FormattedMessage
              id="userDetails-completedSteps-title"
              defaultMessage="Completed Steps"
            />
          </h3>
        </div>
        <div className="card-body pt-2">
          {
            (data.length === 0)
              ? <Empty/>
              : (
                <>
                  <div className="files-list mb-3 d-flex flex-column align-items-start">
                    {steps.map(mapSteps)}
                    <div/>
                  </div>
                </>
              )
          }
        </div>
      </div>
    </>
  );
}
